export const environment = {
  production: false,
  recaptcha: {
    siteKey: '6LcXWPMrAAAAABsv_S5SX4LaHF8jPsA0CqiHq5vv', // Clave de prueba de Google
  },
  matomo: {
    scriptUrl:
      'https://cdn.matomo.cloud/sahulfb.matomo.cloud/container_mXBKleXN.js',
    apiUrl: 'https://sahulfb.matomo.cloud/matomo.php',
    siteId: '6',
    authToken: '3ad90a390552195c8c17c0a30783351a',
    enabled: true,
  },
  // 🆕 Configuración de API
  api: {
    odoo: {
      baseUri: 'https://api-odoo-tenorio.qa.onelink.net.ve',
      token: '4|mgsgkaKTIWOMnLZbtHNPPik9H1w1VO4IDveO3eHDf73d770d',
      endpoint: '/api/crm-lead',
      enabled: true,
    },
    tracking: {
      baseUrl: 'https://api-gateway-clientes.qa.onelink.net.ve',
      token: '2|1rypchKnGLeyFU1qUJiPmb6MqpMrI7wpnrcNaWyw30098ce9',
      enabled: true,
      endpoints: {
        lastVisit: '/api/tracking/get-last-visit',
      },
    },
  },

  encryption: {
    key: 'e7+cRH7ws3tbjnPxKmsUOmHsPEAZ5E+trmkORKr5akY=',
    algorithm: 'aes-256-cbc',
  },
};
